import { AxiosRequestHeaders } from 'axios';
import { InternalHttpServiceRequestHeaders } from '../http.service';

export const apimKeyInterceptor = (config: InternalHttpServiceRequestHeaders): InternalHttpServiceRequestHeaders => {
  if (!config.headers) {
    (config.headers as Partial<AxiosRequestHeaders>) = {
      'Content-Type': 'application/json',
    };
  }
  if (config.baseURL?.startsWith('https://apim.stihl.cloud')) {
    if (!config.headers) {
      (config.headers as Partial<AxiosRequestHeaders>) = {};
    }
    config.headers['Ocp-Apim-Subscription-Key'] = (process.env.NEXT_PUBLIC_OCP_APIM_SUBSCRIPTION_KEY as string) || '';
  }

  return config;
};
